export interface NoltUrlConfig {
  noltBoardUrl: string;
  noltMappingPrefix: string;
  withHeader: boolean;
}

export function directWidgetUrl(config: NoltUrlConfig): string {
  const url = new URL(config.noltBoardUrl);
  url.pathname = url.pathname.replace(/\/+$/, "") + "/widget";
  url.search = "withHeader=" + String(config.withHeader);
  return url.toString();
}

export function widgetUrl(
  config: NoltUrlConfig,
  discordProxy: boolean,
): string {
  return discordProxy
    ? "/widget?withHeader=" + String(config.withHeader)
    : directWidgetUrl(config);
}

export function ssoWidgetUrl(
  config: NoltUrlConfig,
  token: string,
  discordProxy: boolean,
  activityOrigin: string,
): string {
  if (discordProxy) {
    const returnUrl = new URL(widgetUrl(config, true), activityOrigin);
    const url = new URL(
      "/sso/" + encodeURIComponent(token),
      activityOrigin,
    );
    url.searchParams.set("returnUrl", returnUrl.toString());

    // Keep both the SSO request and its return URL on the Discord proxy origin.
    // Otherwise the session created through the mapped endpoint is not available
    // after Nolt redirects into the widget.
    return url.pathname + url.search;
  }

  const returnUrl = directWidgetUrl(config);
  const url = new URL(config.noltBoardUrl);
  url.pathname =
    url.pathname.replace(/\/+$/, "") + "/sso/" + encodeURIComponent(token);
  url.searchParams.set("returnUrl", returnUrl);
  return url.toString();
}
